<iframe [src]="gameUrl | safe" id="element" class="fit" height='{{scrHeight}}px' allow="autoplay; encrypted-media"
    marginheight="0px" marginwidth="0px" frameborder="0" allowfullscreen webkitallowfullscreen="true"
    mozallowfullscreen="true">
</iframe>
<a (click)="back()" class="back">Back</a>

<!-- Modal -->
<div class="popup" *ngIf="showModalBox">
    <div class="modal-dialog modal-width">
        <div class="modal-content">
            <div class="modal-header">
                <!-- <button type="button" class="close" (click)="closeModal()">
                    <span aria-hidden="true" data-dismiss="modal">×</span>
                </button> -->
                <!-- <h3 class="modal-title modal-title-color">Please Subscribe first</h3> -->

                <h3 class="modal-title modal-title-color">Please use your Safaricom Internet to access this service.
                </h3>
                <a type="button" class="btn btn-primary" (click)="closeModal()">OK</a>
            </div>

        </div>
    </div>
</div>